import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
/**
  Componente para mostrar un modal relacionado con avisos para Canadá.
  Este componente permite cerrar el modal y redirigir al usuario a la página de inicio
  o a la página de información de vuelos.
**/
@Component({
    selector: 'app-modal-canada',
    templateUrl: './modal-canada.component.html',
    styleUrls: ['./modal-canada.component.scss'],
    standalone: false
})
export class ModalNoticeCanadaComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private router: Router,
    ) { }

  ngOnInit(): void {
  }
  /**
    Cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario decide ir a la información de vuelos.
    @return void - No retorna ningún valor.
  **/
  goToFlightInfo() {
    this.modalService.dismissAll()
  }
   /**
    Redirige al usuario a la página de inicio y cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario decide regresar al inicio.
    @return void - No retorna ningún valor.
  **/
  goToInit() {
    this.router.navigate(['/'])
    this.modalService.dismissAll()
  }
}
